.staff {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.chordRow {
  display: grid;
  grid-template-columns: repeat(var(--chord-count, 4), 1fr);
  gap: 4px;
}

.chordHeader {
  text-align: center;
  font-weight: 500;
  padding: 4px;
  background: var(--tuna-palette-background-default);
  border-radius: var(--tuna-shape-radius-sm);
}

.grid {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pitchRow {
  display: grid;
  grid-template-columns: repeat(var(--chord-count, 4), 1fr);
  gap: 4px;
}

.slot,
.slotFilled {
  height: 24px;
  border: 1px solid var(--tuna-palette-divider);
  background: transparent;
  cursor: pointer;
  border-radius: var(--tuna-shape-radius-sm);
}

.slot:hover {
  background: var(--tuna-palette-action-hover);
}

.slotFilled {
  background: var(--tuna-palette-primary-main);
}

.slot:focus-visible,
.slotFilled:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

@media (max-width: 599.95px) {
  .slot,
  .slotFilled {
    height: 44px;
  }
}
